webpackJsonp([209063065961547],{

/***/ 437:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Windpro's blog","subtitle":"Python, JavaScript 全栈之路.","copyright":"© All rights reserved.","menu":[{"label":"Articles","path":"/"},{"label":"Categories","path":"/categories/"},{"label":"About me","path":"/about/"}],"author":{"name":"Windpro Zhao","email":"windprog@gmail.com","telegram":"#","twitter":"#","github":"windprog","rss":"/rss.xml","vk":"#"}}},"allMarkdownRemark":{"edges":[{"node":{"fields":{"slug":"/posts/learn-css","categorySlug":"/categories/css/"},"frontmatter":{"title":"CSS 常用属性","date":"2018-04-18 21:05:00","category":"CSS","description":""}}},{"node":{"fields":{"slug":"/posts/learn-css-layout-float","categorySlug":"/categories/css/"},"frontmatter":{"title":"学习CSS布局（一）流布局（Normal Flow）","date":"2018-04-16 15:48:00","category":"CSS","description":""}}}]}},"pathContext":{"tag":"CSS"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-css-adac85ef6cd47feaf78f.js